// Fallback city data for when geocoding API is unavailable
// Primary location search now uses OpenStreetMap Nominatim API (see geocodingService.js)
// This list serves as backup for the most common locations

export const fallbackCitiesData = [
    // Major US cities
    { name: "New York, USA", lat: 40.7128, lng: -74.0060 },
    { name: "Los Angeles, USA", lat: 34.0522, lng: -118.2437 },
    { name: "Chicago, USA", lat: 41.8781, lng: -87.6298 },
    { name: "San Francisco, USA", lat: 37.7749, lng: -122.4194 },

    // Major international cities
    { name: "London, UK", lat: 51.5074, lng: -0.1278 },
    { name: "Paris, France", lat: 48.8566, lng: 2.3522 },
    { name: "Tokyo, Japan", lat: 35.6762, lng: 139.6503 },
    { name: "Sydney, Australia", lat: -33.8688, lng: 151.2093 },
    { name: "Berlin, Germany", lat: 52.5200, lng: 13.4050 },
    { name: "Rome, Italy", lat: 41.9028, lng: 12.4964 },
    { name: "Toronto, Canada", lat: 43.6532, lng: -79.3832 },
    { name: "Amsterdam, Netherlands", lat: 52.3676, lng: 4.9041 }
];

// Keep original export name for backward compatibility
export const citiesData = fallbackCitiesData; 